import { useWindowScroll } from '@mantine/hooks'
import classes from './Scroll.module.css'
import { useMemo } from 'react'

export function useScroll() {
  const [scroll] = useWindowScroll()
  const isScrolled = useMemo(() => scroll.y > 1, [scroll.y])

  return isScrolled ? classes.scrollContainer : ''
}
